import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getRegularLists,
// 获取列表数据
getRegularInfo,
// 试用期管理枚举项
regularExport as _regularExport // 转正管理列表导出
} from '@/api/org/per';
import { getAllListFn as _getAllListFn } from 'api/org/position';
import depTree from '@/components/dep-tree';
import Edit from './edit';
export default {
  components: {
    depTree: depTree,
    Edit: Edit
  },
  data: function data() {
    return {
      dataList: {
        list: [],
        total: 0
      },
      regularInfo: {
        staff_formal_state: {},
        // 试用期状态
        staff_evaluate_state: {},
        // 试用期评估状态
        notice_date: {},
        // 提醒时间条件
        notice_date_type: {},
        // 操作类型
        send_to: {},
        // 通知对象
        notice_type: {} // 通知方式
      },

      pageSizes: [100, 50, 20],
      dataForm: {
        page: 1,
        page_size: 100,
        search_name: '',
        formal_state: ['1'],
        evaluate_state: '',
        department_id: '',
        job_id: '',
        state: '',
        hire_date_start: '',
        hire_date_end: '',
        formal_date_start: '',
        formal_date_end: '',
        sort: '',
        // 排序相关
        dir: '' // 排序顺序，asc 升序，desc 降序
      },

      depInfoName: '',
      hire_date: [],
      formal_date: [],
      tableLoading: false,
      visible: false,
      current: {},
      currentRule: {},
      tableSelectArr: [],
      posiOptions: [],
      popover: false,
      posiAllList: [],
      multipleSelection: []
    };
  },
  computed: {
    errorFormalDate: function errorFormalDate() {
      return function (row) {
        // 已过转正日期，试用期状态仍为试用期中，日期标红显示
        var data = new Date().getTime() > new Date(row.formal_date).getTime() + 86400000;
        if (data && row.formal_state === '1') return true;
        return false;
      };
    }
  },
  mounted: function mounted() {
    this.regularInfoFn(); // 试用期管理枚举项
    this.getTableData(1);
    this.getAllListFn();
  },
  methods: {
    regularInfoFn: function regularInfoFn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getRegularInfo();
            case 2:
              res = _context.sent;
              // 试用期管理枚举项
              if (res && res.code === 1) _this.regularInfo = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getTableData: function getTableData(page) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 获取列表数据
              _this2.tableLoading = true;
              _this2.dataForm.page = page || _this2.dataForm.page;
              _context2.next = 4;
              return getRegularLists(_objectSpread({}, _this2.dataForm));
            case 4:
              res = _context2.sent;
              _this2.tableLoading = false;
              if (res && res.code === 1) {
                _this2.$nextTick(function () {
                  _this2.$refs.tableList && _this2.$refs.tableList.doLayout();
                });
                _this2.dataList = _objectSpread({
                  list: res.data.list
                }, res.data.page_data);
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      // 排序
      this.dataForm.sort = prop;
      this.dataForm.dir = order;
      this.getTableData(1);
    },
    regularExport: function regularExport() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _regularExport(_objectSpread({}, _this3.dataForm));
            case 2:
              res = _context3.sent;
              window.location.href = res.data.down_load_excel.object_url;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onInvite: function onInvite() {
      // 试用期设置
      this.$router.push({
        path: '/staff/pemploymenter/setting',
        query: {
          active: '3',
          name: 'STAFF_PROBATION_DAY'
        }
      });
    },
    handleNodeClick: function handleNodeClick(val) {
      // 部门回调函数
      this.depInfoName = val.department_name;
      this.dataForm.department_id = val.department_id;
      this.popover = false;
    },
    departmentClear: function departmentClear() {
      this.dataForm.department_id = null;
    },
    handleDateChange: function handleDateChange(v, type) {
      // 处理时间
      if (v) {
        var _v = _slicedToArray(v, 2),
          start = _v[0],
          end = _v[1];
        this.dataForm[type + '_start'] = start;
        this.dataForm[type + '_end'] = end;
      } else {
        this.dataForm[type + '_start'] = '';
        this.dataForm[type + '_end'] = '';
      }
    },
    getAllListFn: function getAllListFn() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _getAllListFn();
            case 2:
              res = _context4.sent;
              _this4.posiAllList = res.data;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    remoteMethod: function remoteMethod(query) {
      // 职位
      var obj = this.posiAllList.filter(function (v) {
        return v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
      this.posiOptions = query !== '' ? obj : [];
    },
    sizeChangeHandle: function sizeChangeHandle(val) {
      // 每页条数
      this.dataForm.page_size = val;
      this.getTableData(1);
    },
    currentChangeHandle: function currentChangeHandle(val) {
      // 切换 页
      this.getTableData(val);
    },
    onEdit: function onEdit(item, type) {
      // 转正处理、编辑
      this.$refs.edit.init(item, type);
    },
    refreshTableList: function refreshTableList() {
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteStaff: function handleDeleteStaff() {
      var _this5 = this;
      this.$confirm(this.$t('delete.msg', {
        x: this.multipleSelection.length
      }), this.$t('prompt'), {
        confirmButtonText: this.$t('submit_btn'),
        cancelButtonText: this.$t('cancel_btn'),
        type: 'warning'
      }).then(function () {
        return _this5.$http({
          url: '/web/staff_regular/removeStaffRegular',
          data: {
            staff_id: _this5.multipleSelection.map(function (item) {
              return item.staff_id;
            })
          }
        });
      }).then(function (res) {
        _this5.getTableData(1);
      }).catch(function () {});
    }
  }
};